import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { createStore } from 'satcheljs';
import { FileProviderFolderSelectorStore } from './schema/FileProviderFolderSelectorStore';
import { FolderSelectorError } from './schema/FolderSelectorError';

const defaultStore: FileProviderFolderSelectorStore = {
    selectedProviderType: AttachmentDataProviderType.OneDrivePro,
    folders: [],
    breadcrumbs: [],
    isOpen: false,
    isLoading: false,
    error: FolderSelectorError.None,
    createFolderViewState: {
        isCreating: false,
        isUserEnteringText: false,
    },
};

export const getStore = createStore<FileProviderFolderSelectorStore>(
    'fileProviderFolderSelectorStore',
    defaultStore
);
